import ComponentManager from '@/Management/ComponentManager';
import ListViewViewModel from '@/ViewModels/Views/ListViewViewModel';
import * as CoreFrameDTOs from "coreframetypings/dto";
import Utilities from '@/Utility/Utilities';
import {
    IEmbeddedListViewViewModelParameters,
    IFilterViewModelConstructorParameter,
    ToolBarItemViewModel
} from "#/DefaultViewExtensionInterfaces";
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import {IListViewDTO} from "coreframetypings/dto";
import SplitterViewModelT from '@/ViewModels/Controls/SplitterViewModel';

export default class EmbeddedListViewViewModel extends ListViewViewModel {

    public inheritPersistenceContext: boolean;
    public isDisplayed: KnockoutObservable<boolean>;
    public forceShowAllFilterFunctions: boolean;

    public constructor(private params: IEmbeddedListViewViewModelParameters) {
        super($.extend(params, { isInherited: true, isEmbedded: true }));

        this.showPrincipalFilter = false;
        this.filter = this.paramOrDefault(params.filter, '');
        this.inheritPersistenceContext = this.paramOrDefault(params.inheritPersistenceContext, false);
        this.isDisplayed = this.observableOrDefault(params.isDisplayed);
        this.loadListView();
        this.forceShowAllFilterFunctions = this.paramOrDefault(params.forceShowAllFilterFunctions, false);
    }

    /**
     * Aktualisiert die eingebettete ListView
     * @override
     */
    public refresh(): boolean {
        if (this.isDisposed)
            return false;

        if (this.inheritPersistenceContext) {
            if (!this.dataGrid)
                return false;

            this.dataGrid.refresh();
            return true;
        } else {
            return super.refresh();
        }
    }

    /**
    * @override
    */
    protected showAllFilterFunctions(): boolean {
        return this.forceShowAllFilterFunctions;
    }

    /**
     * @override
     */
    public createToolbar(listView: IListViewDTO) {
        listView.showFilter = this.paramOrDefault(this.params.showFilter, true);
        listView.showButtonEdit = this.paramOrDefault(this.params.showEdit, true);
        listView.showButtonDelete = false;
        listView.showButtonDisconnect = false;
        listView.showButtonSelect = false;
        listView.showButtonCreate = false;
        return super.createToolbar(listView);
    }

    /**
     * @override
     */
    protected createDataGridViewModelParameters(listView: CoreFrameDTOs.IListViewDTO): any {
        let params = super.createDataGridViewModelParameters(listView);
        
        params.isDisplayed = this.isDisplayed;
        
        if (this.params.detailViewContext != null) {
            // In einer DV/SV kann eine EmbeddedListView fast wie ein AssociationGrid verwendet werden. 
            // Deshalb wird hier standardmäßig die Höhe davon verwendet.
            params.height = this.observableOrDefault(params.height,
                GlobalConfiguration.dataGrid.HeightForAssociationGridInDV,
                (value) => {
                    if (value.indexOf("%") == -1) {
                        let int = parseInt(value, 10);
                        if (isNaN(int) || int < GlobalConfiguration.dataGrid.MinHeightForAssociationGridInDV) {
                            return GlobalConfiguration.dataGrid.HeightForAssociationGridInDV;
                        }
                        return int + "px";
                    }
                    else
                        return value;
                });

            // In einer DV/SV soll das Grid höhenverstellbar sein
            params.verticalResize = {
                isUserResizeEnabled: true,
                storageKeyPrefix: listView.name
            };
        }
        
        return params;
    }

    /**
     * @override
     */
    protected createAdditionalFilterConstructorParameter(listView : CoreFrameDTOs.IListViewDTO): IFilterViewModelConstructorParameter {
        let params = super.createAdditionalFilterConstructorParameter(listView);

        if (this.params.detailViewContext != null)
            params.publicUserData = this.params.detailViewContext.publicUserData['LV: ' + listView.typeName]

        return params;

    }

    /**
     * @override
     */
    protected isFavoritesVisible(): boolean {
        return false;
    }

    /**
     * @override
     */
    public getStorageColumnDefinitionKey(listViewDto: CoreFrameDTOs.IListViewDTO) : string {
        if (Utilities.isFunction(this.params.getStorageColumnDefinitionKey))
            return this.params.getStorageColumnDefinitionKey(listViewDto);
        else
            return super.getStorageColumnDefinitionKey(listViewDto);
    }

    /**
     * @override
     */
    public onEdit(pdoId: string, openInNewWindow: boolean) {
        if (Utilities.isFunction(this.params.onEdit))
            this.params.onEdit(pdoId, openInNewWindow);
        else
            super.onEdit(pdoId, openInNewWindow);
    }

    /**
     * @override
     */
    public onBeforeListViewLoaded(listViewDTO: CoreFrameDTOs.IListViewDTO) {
        if (Utilities.isFunction(this.params.onBeforeListViewLoaded))
            this.params.onBeforeListViewLoaded(listViewDTO);
        else
            super.onBeforeListViewLoaded(listViewDTO);
    }

    /**
     * @override
     */
    public afterDataGridCreated() {
        super.afterDataGridCreated();

        if (Utilities.isFunction(this.params.afterDataGridCreated))
            this.params.afterDataGridCreated();
    }

    /**
     * @override
     */
    public createExportLinks(listView: IListViewDTO): ToolBarItemViewModel[] {
        return [];
    }

    /**
     * @override
     */
    public createStaticOperationLinks(listView: IListViewDTO): ToolBarItemViewModel[] {
        return [];
    }

    /**
     * @override
     */
    protected resetCurrentListViewContext(): void {
    }
}

ComponentManager.setViewModel('EmbeddedListViewViewModel', EmbeddedListViewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');